import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { AppState } from '../../../../redux/store';

interface ReviewHitsState {
  assignedClusterPendingScans: number | null;
}

const initialState: ReviewHitsState = {
  assignedClusterPendingScans: null,
};

export const reviewHitsSlice = createSlice({
  name: 'reviewHits',
  initialState,
  reducers: {
    setAssignedClusterPendingScans: (state, action: PayloadAction<number | null>) => {
      state.assignedClusterPendingScans = action.payload;
    },
    clearAssignedClusterPendingScans: (state) => {
      state.assignedClusterPendingScans = null;
    },
  },
});

export const { reducer: reviewHitsReducer } = reviewHitsSlice;

export const { setAssignedClusterPendingScans, clearAssignedClusterPendingScans } = reviewHitsSlice.actions;

export const selectAssignedClusterPendingScans = (state: AppState): number | null =>
  state.reviewHitsReducer.assignedClusterPendingScans;
